const FILTER_FIELDS = [
    'carrier_id', 'livedetails', 'name', 'vehicle_type',
    'features', 'book', 'preferred_currency', 'supplementalinfo',
    'ticketDelivery', 'groups', 'book', 'canonical_slug',
];

const MIX_TRIP_CARRIER_CODE = 'MIX';

export {
    FILTER_FIELDS,
    MIX_TRIP_CARRIER_CODE,
};
